import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InstallNodePackageManagers from "./install-node-package-managers.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Install `}<inlineCode parentName="p">{`posthog-node`}</inlineCode>{` using your package manager:`}</p>

    <InstallNodePackageManagers mdxType="InstallNodePackageManagers" />
    <p>{`Then, initialize the PostHog Node client where you'd like to use it on the server side. For example, in a `}<a parentName="p" {...{
        "href": "https://kit.svelte.dev/docs/load#page-data"
      }}>{`load function`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "file=routes/+page.server.js",
        "file": "routes/+page.server.js"
      }}>{`import { PostHog } from 'posthog-node';

export async function load() {
  const posthog = new PostHog('<ph_project_api_key>', { host: '<ph_client_api_host>' });

  posthog.capture({
    distinctId: 'distinct_id_of_the_user',
    event: 'event_name',
  })

  await posthog.shutdown()
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Make sure to always call `}<inlineCode parentName="p">{`posthog.shutdown()`}</inlineCode>{` after capturing events from the server-side. PostHog queues events into larger batches, and this call forces all batched events to be flushed immediately.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      